var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonCalendar.jinja');
require('./CommonCalendar.less');

require('jquery-ui/ui/widgets/datepicker.js');
require('./DatePickerSettings.js');

var moment = require('moment/moment');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'destroy', 'onBodyClick', 'onKeyDown');

        $('body').on('keydown', this.onKeyDown);

        var self = this;

        this.$calendar = this.$('.CommonCalendar-calendar');

        $.datepicker.setDefaults($.datepicker.regional.en);

        var dt = this.options.date;

        if (dt) {
            dt = moment(dt).format('YYYY-MM-DD');
        }

        this.$calendar.datepicker({
            // altField: this.$input,
            dateFormat: 'yy-mm-dd',
            defaultDate: dt,
            minDate: this.options.allowPastDates ? null : 0,
            onSelect: function (dateStr) {
                var dt = moment(dateStr).toISOString();
                self.trigger('select', dt);
                self.destroy();
            },
            onChangeMonthYear: function () {
                self.disableBodyClickHandler = true; //becouse onChangeMonthYear removes component entirely from doom, so  ($(e.target).closest('.CommonCalendar').length) is failed
                setTimeout(function () {
                    self.disableBodyClickHandler = false;
                }, 300);
            }.bind(this)
        });

        Base.prototype.initialize.call(this, options);
    },


    show: function () {
        this.$calendar.datepicker('show');

        $('body').off('click', this.onBodyClick);

        setTimeout(function () {
            $('body').on('click', this.onBodyClick);
        }.bind(this), 100);
    },


    onBodyClick: function (e) {
        if ($(e.target).closest('.CommonCalendar').length) return;

        if (this.disableBodyClickHandler) return;

        this.destroy();
    },


    onKeyDown: function (e) {
        if (e.keyCode == 27) { //esc
            e.stopPropagation();

            this.destroy();
        }
    },


    destroy: function () {
        this.$calendar.datepicker('destroy');

        $('body').off('keydown', this.onKeyDown);

        this.trigger('close');

        $('body').off('click', this.onBodyClick);

        return Base.prototype.destroy.call(this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonCalendar/CommonCalendar.js
// module id = 64
// module chunks = 0